import styled from 'styled-components';
import DefaultButton from 'components/Buttons/Button';
import DefaultActionButton from 'components/Buttons/ActionButton';
import { H3 } from 'components/Typography';
import DefaultDetails from './Details';
import DefaultApliesTo from './AppliesTo';
import DefaultModifiers from './Modifiers';

const actionBarHeight = '6rem';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 45.6875rem;
  margin: 0 auto;
  margin-bottom: calc(${actionBarHeight} + 2rem);
`;

export const SectionTitle = styled(H3)`
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Details = styled(DefaultDetails)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const ApliesTo = styled(DefaultApliesTo)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Modifiers = styled(DefaultModifiers)``;

// TODO: TFR-49 split components into two or more different logical components
export const ActionBar = styled.div`
  position: fixed;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(0, 0, 0, 0.1),
    0rem 0.5rem 2rem rgba(0, 0, 0, 0.1);
  height: ${actionBarHeight};
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Actions = styled.div`
  width: 100%;
  max-width: 45.6875rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const ActionButton = styled(DefaultActionButton)``;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-left: 1rem;
`;
